export default {
  path: '/alarms/reminders',
  name: 'Reminders',
  component: () => import(/* webpackChunkName: "base" */ '../views/RemindersView.vue'),
  meta: {
    exclude: false,
    requiresAuth: true
  }
}
